import React from 'react';

import { TIPTAP_FIGURE_TYPE } from './../ricos-content/consts';
import type { PluginContainerData_Width_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { RicosServices, ToolbarButton } from './../ricos-types';
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID,
} from './../editor-common';
import { getVisibleOnlyOnDesktopResolver } from './../plugin-commons';
import {
  AlignmentPanel,
  DeleteButton,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel,
} from './../toolbars-ui';
import { FLOATING_PLUGIN_TOOLBAR } from './../toolbars-v3';

import { GIF_BUTTONS, gifModals } from './constants';
import { GiphyInsertModal } from './modals/InsertModal';

export const getToolbarButtons = (config: $TSFixMe, services: RicosServices): ToolbarButton[] => {
  const {
    context: { isMobile },
  } = services;

  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: [
            'SMALL',
            'CONTENT',
            'FULL_WIDTH',
            'ORIGINAL',
          ] as PluginContainerData_Width_Type[],
        }),
        id: GIF_BUTTONS.size,
      },
      renderer: toolbarItem => <NodeSizeButton id={GIF_BUTTONS.size} toolbarItem={toolbarItem} />,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: GIF_BUTTONS.alignment,
      },
      renderer: toolbarItem => (
        <NodeAlignmentButton toolbarItem={toolbarItem} id={GIF_BUTTONS.alignment} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(GiphyInsertModal, {
          modalId: gifModals.replace,
          getGiphyUrl: config?.getGiphyUrl,
        }),
        id: gifModals.replace,
      },
      attributes: {
        active: {
          id: 'IS_GIF_REPLACE_BUTTON_ACTIVE',
          resolve: (_, { modals }) => Boolean(modals.getModal(gifModals.replace)),
        },
      },
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        const { modals } = services;
        modals?.togglePluginPanel({
          id: gifModals.insert,
          Component: GiphyInsertModal,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            modalId: gifModals.insert,
            getGiphyUrl: config?.getGiphyUrl,
          },
          positioning: {
            referenceElement:
              referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ??
              referenceElement,
            placement: 'right-start',
          },
          isMobile,
          focusReturnElement: referenceElement,
        });
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      renderer: toolbarItem => {
        return <DeleteButton toolbarItem={toolbarItem} />;
      },
      command: data => {
        const figures = data.tiptapEditor.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find(f => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });

        if (selectedFigure) {
          data.tiptapEditor.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      },
    },
  ];
};
